import { AbstractControl, UntypedFormControl, FormGroupDirective, NgForm, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { SnackBarService } from '@shared/components/snackbar-message/services/snackbar.service';
import { MirSnackbarType } from '@shared/components/snackbar-message/model/snackbar';

const isEnglishValid = (sample: string): boolean => {
  const regex = /^[~`!@#$%^&*()_+=[\]\\{}|;':",./<>?A-Za-z0-9-\s]+$/;
  return regex.test(sample);
};

const isUrlValid = (sample: string): boolean => {
  /* eslint-disable */
  const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  return urlRegex.test(sample);
};

export const englishTextValidator = (control: AbstractControl): { [key: string]: any } | null => {
  if (!isEnglishValid(control.value as string)) {
    return { englishText: 'INFORMATION_PLACEMENT_FORM.ENGLISH_ERROR' };
  }

  return null;
};

export const numberValidator = (control: AbstractControl): { [key: string]: any } | null => {
  if (control.value && isNaN(+control.value)) {
    control.setValue('', { emitEvent: false });
    return { errorNumber: 'OTHER.CAPTCHA_NUMBER_VALID' };
  }
  return null;
};

export const maxValidator = (max: number, snackBar: SnackBarService): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const currentValue = control.value;
    if (currentValue && !isNaN(+currentValue) && max < +currentValue || isNaN(+currentValue)) {
      control.setValue(currentValue.toString().slice(0, -1), { emitEvent: false });
      snackBar.open(MirSnackbarType.Warning, [
        {
          message: 'SNACK_BAR_MESSAGE.RADIUS_MAX',
          translate: true
        },
        {
          message: ' ' + max + ' ',
          translate: false
        },
        {
          message: 'OTHER.METER',
          translate: true
        }
      ]);
      return { errorNumber: 'SNACK_BAR_MESSAGE.RADIUS_MAX' };
    }
    return null;
  };
};

export const whitespaceValidator = (control: AbstractControl): { [key: string]: any } | null => {
  if (control.value && typeof control.value === 'string' && control.value?.startsWith(' ')) {
    control.setValue(control.value.trim(), { emitEvent: false });
    return { errorSpace: 'OTHER.CAPTCHA_NUMBER_WHITESPACE_VALID' };
  }
  return null;
};

export const urlTextValidator = (control: AbstractControl): { [key: string]: any } | null => {
  if (!isUrlValid(control.value as string)) {
    return { urlText: 'INFORMATION_PLACEMENT_FORM.URL_ERROR' };
  }
  return null;
};

export class AppSelectErrorStateMatcher implements ErrorStateMatcher {
  constructor(private ngControl: UntypedFormControl) {}
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && this.ngControl.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
